<template>
<div class="border">
  <el-row justify="center">
    <el-col class="formContainer" :xs="24" :sm="24" :md="20" :lg="24" :xl="24">
      <el-form label-position="top" label-width="100px" :model="inventoryAdjustment" :rules="rules" ref="adjustmentForm">
        <el-row :gutter="20">
          <el-col  :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-form-item :label="$t('adjustments.adjusmentMode')">
              <el-radio :value="adjustment.mode" :label="0">{{$t('adjustments.quantity')}}</el-radio>
              <el-radio v-model="adjustment.mode" :label="1" :disabled="true">{{$t('adjustments.value')}}</el-radio>
            </el-form-item>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.referenceLbl')">
              <el-input :placeholder="$t('adjustments.referenceNumber')" v-model="reference"></el-input>
            </el-form-item>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.effectiveDate')" prop="date">
              <el-date-picker
                v-model="inventoryAdjustment.date"
                type="date"
                :placeholder="$t('adjustments.chooseDate')"
                @change="setDate">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.batchLbl')" prop="item">
              <el-select v-model="inventoryAdjustment.item" :placeholder="$t('common.select.placeholder')" value-key="id" @change="setItem">
                <el-option
                  v-for="item in productItems"
                  :key="item.id"
                  :label="getItemLabel(item)"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="adjustedProduct.item">
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.availableQuantity')">
              <el-input v-if="adjustedProduct!=null && adjustedProduct.item!=null" size="small" :value="adjustedProduct.item.quantity.onHand" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.adjustedQuantity')">
              <el-input-number v-model="adjusted_qty" :controls="false" size="small"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <el-form-item :label="$t('adjustments.adjustment')" prop="diff">
              <el-input-number v-model="inventoryAdjustment.diff" @change="setDiff" size="small"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col  :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('adjustments.reasonLbl')" prop="reason">
              <el-select v-model="inventoryAdjustment.reason" placeholder="Select" value-key="id" @change="setReason">
                <el-option
                  v-for="item in reasons"
                  :key="item.id"
                  :label="item.name"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col  :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
            <el-form-item :label="$t('adjustments.description')">
              <el-input type="textarea" :rows="4"  v-model="description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row justify="end">
          <el-col>
            <el-button @click="close">{{ $t('common.cancel') }}</el-button>
            <el-button type="primary" @click="save">{{ $t('common.save') }}</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-col>
  </el-row>
</div>
</template>
<script>
import moment from 'moment-timezone'
import dayjs from 'dayjs';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'InventoryAdjustmentForm',
	props: {
    product : null,
    productItems : null,
    editSelectedAdjustment : {
      type : Boolean,
      default : false
    },
    inventoryId : Number
	},
  data() {
    return {
      inventoryAdjustment : {
        date : null,
        reason : null,
        diff : null,
        item : null,
      },
      rules : {
  	  	date : [
  	  		 	{ required: true, message: 'Veuillez saisir une date', trigger: 'blur' }
  	  		],
        reason : [
          	{ required: true, message: 'Veuillez sélectionner une raison', trigger: 'blur' }
        ],
        diff : [
  	  		 	{ required: true, message: 'Veuillez saisir une valeur', trigger: 'blur' }
  	  		],
        item : [
          { required: true, message: 'Veuillez saisir un lot à ajuster', trigger: 'blur' }
        ]
  	  },
      fullScreenLoading : false,
    };
  },components: {

  },
	methods: {

    setReason(reason){
      this.setAdjustmentProp({reason})
    },
    setItem(item){
      this.setAdjustedProductItem(item)
    },
    setDiff(diff){
      this.setAdjustedProductQuantity({diff})
    },
    getItemLabel(item){
      let label =  this.moment(item.availabilityDate);
      if(item.reference!=null && item.reference!=""){
        label+=" - " + item.reference;
      }
      return label;
    },
    moment(datetime){
			return  moment(datetime).format('LL');
		},
    setDate(effective_date){
      this.setAdjustmentProp({effective_date})
    },
    close(){
       this.reset();
       this.$refs['adjustmentForm'].resetFields();
       this.$emit('close');
    },
    save(){

      this.$refs['adjustmentForm'].validate((valid)=>{
        if(valid){
          this.postAdjustment()
            .then(response=>{
              this.fetchAdjustments({productId:this.product.id, inventoryId : this.inventoryId});
              this.$emit('adjusted');
              this.close();
              this.$message({
                message: "L'ajustement d'inventaire a été sauvegardé avec succès!",
                type: 'success'
              });
            })
        }else{
          this.$notify({
              title: 'Avertissement',
              message: "Certains champs obligatoires n'ont pas été renseignés.",
              type: 'warning'
            });
        }
      })

    },
    ...mapActions('inventoryAdjustmentEditor',['fetchReasons', 'reset','setAdjustmentProp', 'initAdjustment','setAdjustedProductQuantity','setAdjustedProductItem','postAdjustment']),
    ...mapActions('inventoryAdjustment',['fetchAdjustments'])
	},
	computed: {
    defaultProductItem () {
      return _.get(_.find(this.productItems, productItem => _.get(productItem, 'quantity.onHand') > 0), 'id');
    },
    today () {
      return dayjs().format();
    },
    reference : {
      set(reference){this.setAdjustmentProp({reference})},
      get(){return this.adjustment.reference}
    },
    description : {
      set(description){this.setAdjustmentProp({description})},
      get(){return this.adjustment.description}
    },
    adjusted_qty : {
      set(adjusted_qty){this.setAdjustedProductQuantity({adjusted_qty})},
      get(){return this.adjustedProduct.adjusted_qty}
    },
    isEditionMode(){
      return this.editSelectedAdjustment;
    },
    ...mapState('inventoryAdjustmentEditor',['adjustment', 'reasons','adjustedProduct'])
	},
  mounted(){
    this.inventoryAdjustment.date = this.today;
    this.setAdjustmentProp({effective_date: this.inventoryAdjustment.date })
  },
  created(){
      this.fetchReasons();
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/_variables';




</style>
